import { LitElement, css, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { resolveRouterPath } from '../router';
import { db } from '../modules/db';

import '@shoelace-style/shoelace/dist/components/button/button.js';
@customElement('app-sidebar')
export class AppSidebar extends LitElement {
  @property({ type: String }) title = 'Note.md';
  @property({ type: Boolean}) enableBack: boolean = false;

  static styles = css`
    :host {
      display: flex;
      height: 100%;

      &:hover {
      overflow-y: scroll;
      }
    }
      aside {
  height: 100%;
  width: 130px;
  border-right: 1px solid #222;
  padding: 10px;


  ul,
  li {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    a {
      margin: 0;
    }

    a {
      text-decoration: none;
      color: #eee;
      font-size: 0.9em;
      padding: 0;
      border-radius: 4px;
      width: 100%;
      display: block;
      display: flex;
      align-items: center;
      gap: 4px;

      &:hover,
      &:focus {
        color: #fff;
      }

      svg {
      width: 1.2rem}
    }

    h4 {
      font-size: 0.8em;
      text-transform: uppercase;
      color: #888;
    }
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 12px;


  }
}
  `;

  private tags = [];
  private folders = [];
  private reloadInterval = null;

  constructor() {
    super();
    this.getTags();
    this.getFolders();

  }

  async toggleCommandPalette() {
    let event = new CustomEvent('events', {
      bubbles: true,
      composed: true,
      detail: {
        action: 'toggle-command-palette',
      }
    });

    this.dispatchEvent(event);
  }

  connectedCallback(): void {
    super.connectedCallback();
    this.reloadInterval = setInterval(() => {
      this.getTags();
      this.getFolders();
    }, 5000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearInterval(this.reloadInterval);
  }

  async getFolders() {
    // Fetch folders from the database and set them as children
    this.folders = [];
    await db.folders.toArray().then(folders => {
      folders.forEach(folder => {
        this.folders.push({
          name: folder.name,
          action: () => {
            // this.sendEvent({action: 'open-folder', folderName: folder.name});
          }
        });
      });
    });
    this.requestUpdate();
  }

  async getTags() {
    // Fetch tags from the database and set them as children
    this.tags = [];
    await db.tags.toArray().then(tags => {
      tags.forEach(tag => {
        this.tags.push({
          name: tag.name,
          action: () => {
            // this.sendEvent({action: 'open-tag', tagName: tag.name});
          }
        });
      });

      this.requestUpdate();
    });
  }

  render() {
    return html`
      <aside>
        <ul>
          <li>
            <h4>Folders</h4>
          </li>
          <li>
            <a href="${resolveRouterPath('/')}"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z" />
</svg> All Notes</a>
          </li>
          ${this.folders.map(folder => html`
          <li>
            <a href="${resolveRouterPath('/')}"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z" />
              </svg> ${folder.name}</a>
          </li>`)}
          <li>
            <a href="${resolveRouterPath('/')}"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
</svg>New Folder</a>
          </li>

          <li>
            <h4>Settings</h4>
          </li>
          <li>
              <a href="${resolveRouterPath('/')}"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16.712 4.33a9.027 9.027 0 0 1 1.652 1.306c.51.51.944 1.064 1.306 1.652M16.712 4.33l-3.448 4.138m3.448-4.138a9.014 9.014 0 0 0-9.424 0M19.67 7.288l-4.138 3.448m4.138-3.448a9.014 9.014 0 0 1 0 9.424m-4.138-5.976a3.736 3.736 0 0 0-.88-1.388 3.737 3.737 0 0 0-1.388-.88m2.268 2.268a3.765 3.765 0 0 1 0 2.528m-2.268-4.796a3.765 3.765 0 0 0-2.528 0m4.796 4.796c-.181.506-.475.982-.88 1.388a3.736 3.736 0 0 1-1.388.88m2.268-2.268 4.138 3.448m0 0a9.027 9.027 0 0 1-1.306 1.652c-.51.51-1.064.944-1.652 1.306m0 0-3.448-4.138m3.448 4.138a9.014 9.014 0 0 1-9.424 0m5.976-4.138a3.765 3.765 0 0 1-2.528 0m0 0a3.736 3.736 0 0 1-1.388-.88 3.737 3.737 0 0 1-.88-1.388m2.268 2.268L7.288 19.67m0 0a9.024 9.024 0 0 1-1.652-1.306 9.027 9.027 0 0 1-1.306-1.652m0 0 4.138-3.448M4.33 16.712a9.014 9.014 0 0 1 0-9.424m4.138 5.976a3.765 3.765 0 0 1 0-2.528m0 0c.181-.506.475-.982.88-1.388a3.736 3.736 0 0 1 1.388-.88m-2.268 2.268L4.33 7.288m6.406 1.18L7.288 4.33m0 0a9.024 9.024 0 0 0-1.652 1.306A9.025 9.025 0 0 0 4.33 7.288" />
              </svg> Documentation</a>
              </li>
            <li>
              <a href="#" @click="${this.toggleCommandPalette}"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="m6.75 7.5 3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0 0 21 18V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v12a2.25 2.25 0 0 0 2.25 2.25Z" />
              </svg>
              Command Palette</a>
              </li>

          ${this.tags.length > 0 ? html`
          <li>
            <h4>Tags</h4>
          </li>` : ''}
          ${this.tags.map(tag => html`<li>
            <a href="${resolveRouterPath('/')}"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 1 0-2.636 6.364M16.5 12V8.25" />
</svg> ${tag.name}</a>
          </li>`)}

          </ul>

      </aside>
    `;
  }
}
